export const ERROR_TYPES = {
  NOT_FOUND: "NOT_FOUND",
  SERVER_ERROR: "SERVER_ERROR",
  NETWORK_ERROR: "NETWORK_ERROR",
  SESSION_IDLE: "SESSION_IDLE",
};

export const ERROR_ROUTES = {
  [ERROR_TYPES.NOT_FOUND]: "/404",
  [ERROR_TYPES.SERVER_ERROR]: "/error/server",
  [ERROR_TYPES.NETWORK_ERROR]: "/error/network",
  [ERROR_TYPES.SESSION_IDLE]: "/error/session",
};

export const ERROR_CONFIG = {
  [ERROR_TYPES.NOT_FOUND]: {
    code: 404,
    title: "Page Not Found",
    message: "The page you are looking for does not exist or has been moved.",
    actionLabel: "Go to Home",
    actionPath: "/",
    backgroundImage: "404",
  },
  [ERROR_TYPES.SERVER_ERROR]: {
    code: 500,
    title: "Something Went Wrong",
    message: "We ran into an unexpected problem. Please try again in a moment.",
    actionLabel: "Refresh Page",
    actionType: "reload",
    backgroundImage: "server",
  },
  [ERROR_TYPES.NETWORK_ERROR]: {
    code: "Offline",
    title: "Connection Problem",
    message: "We could not reach the server. Check your internet connection and try again.",
    actionLabel: "Try Again",
    actionType: "reload",
    backgroundImage: "network",
  },
  [ERROR_TYPES.SESSION_IDLE]: {
    code: "Session",
    title: "Page Idle",
    message: "Please refresh to keep the channel secure.",
    actionLabel: "Refresh",
    actionType: "reload",
    backgroundImage: "session",
  },
};

export function getErrorConfig(type) {
  return ERROR_CONFIG[type] || ERROR_CONFIG[ERROR_TYPES.SERVER_ERROR];
}
